import React from 'react';
import {injectIntl} from 'react-intl';
import messages from '../../../../res/translations/messages';
import {percentualize} from '../../../services/dashboardUtils';
import {fillChartOptions} from '../../../utils/analytics';
import FullscreenChart from './FullscreenChart';

const buildDetailChartOptions = (config, data, hints, intl) => {
    const values = Object.entries(data.series[0].values).map(([key, value]) => value);

    const title = config.title + ' - ' + intl.formatMessage(messages.dashboard.labels.position) + ' ' + (config.series[0].index + 1);
    const count = data.series[0].count;

    return fillChartOptions({
        chart: {
            type: 'column',
        },
        legend: {enabled: false},
        xAxis: {
            categories: data.categories,
            title: {enabled: false, text: title},
        },
        yAxis: {
            title: {enabled: false},
            allowDecimals: false,
        },
        series: [{
            data: values.map((value) => percentualize(value, count, hints)),
            name: data.series[0].name,
            dataLabels: {
                enabled: true,
                format: hints.absolute ? '{point.y}' : '{point.y:.1f}%',
            },
        }],
        tooltip: {
            formatter: function() {
                return hints.absolute ? `${this.y}` : `${this.y}%`;
            },
        },
    }, {...config, title}, data, hints, intl);
};

const buildMainChartOptions = (config, data, hints, intl) => {
    const pairs = Object.entries(data.series[0].values).map(([key, value], index) => [data.categories[index], value]);

    pairs.sort((a, b) => b[1] - a[1]);

    const sortedCategories = pairs.map((pair) => pair[0]);
    const sortedValues = pairs.map((pair) => pair[1]).filter((v) => v > 0); // this enforces showing ony voted pieces
    const title = config.title + ' - ' + intl.formatMessage(messages.surveys.form.label.ranking);

    return fillChartOptions({
        chart: {
            type: 'bar',
        },
        legend: {enabled: false},
        xAxis: {
            categories: sortedCategories,
            title: {enabled: false, text: config.title},
        },
        yAxis: {
            visible: false,
        },
        series: [{
            data: sortedValues.map((value, index) => ({y: value, color:
                (config.max && (index < config.max) || (index >= config.max) && value === sortedValues[config.max - 1]) ||
                !config.max ?
                    '#119BD6' : '#B6B6B5'})),
            name: data.series[0].name,
            dataLabels: {
                enabled: true,
                formatter: function() {
                    return (this.y).toFixed(1);
                },
            },
        }],
        tooltip: {
            formatter: function() {
                return intl.formatMessage(messages.dashboard.labels.score) + ': ' + (this.y).toFixed(1);
            },
        },
    }, {...config, title}, data, hints, intl);
};

const builders = {
    main: buildMainChartOptions,
    detail: buildDetailChartOptions,
};

const buildOptions = (config, data, hints, intl) => {
    if (builders[config.chart]) {
        return builders[config.chart](config, data, hints, intl);
    }
    return builders.main(config, data, hints, intl);
};

const RankWidget = ({intl, data, params, hints}) => {
    if (params.chart === 'detail') {
        return <FullscreenChart hints={hints} options={buildOptions(params, data, hints, intl)} customLabel={`n=${data.count}`} />;
    }
    return <FullscreenChart hints={hints} options={buildOptions(params, data, hints, intl)} customLabel={`n=${data.count}`} />;
};

export default injectIntl(RankWidget);
